<template>
  <div>
    <!-- User Interface controls -->
    <b-row>
      <b-col md="7" class="my-1">
        <b-form-group class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search"/>
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="5" class="my-1">
        <b-form-group label-cols-md="4" label="Per page" class="mb-0">
          <b-form-select :options="pageOptions" v-model="perPage"/>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Main table element -->
    <b-table small striped responsive stacked="md"
             :items="items"
             :fields="fields"
             :current-page="currentPage"
             :per-page="perPage"
             :filter="filter"
             :sort-by.sync="sortBy"
             @filtered="onFiltered"
    >
      <template v-slot:cell(title)="row">
        {{ row.item.title }}
        <div>
          <small>{{ row.item.category }}</small>
        </div>
      </template>
      <template v-slot:cell(actions)="row" class="text-nowrap">
        <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
        <!-- <b-button-group> -->
        <b-button @click.stop="row.toggleDetails" class="btn btn-success mb-2">
          <span class="icon icon-info"></span>
        </b-button>
        <b-button @click="printComp(row.item.id)" class="btn btn-primary mb-2">
          PDF
        </b-button>
        <b-button v-if="sent_already.includes(row.item.id)" disabled class="btn btn-warning mb-2">
          <span class="icon icon-paper-plane"> Sent</span>
        </b-button>
        <b-button v-else @click.stop="sendComp(row.item.id, row.item.title)" class="btn btn-primary mb-2">
          <span class="icon icon-paper-plane"> Send</span>
        </b-button>
        <!-- </b-button-group> -->
      </template>
      <template v-slot:row-details="row">
        <b-card>
          <div class="font-weight-bold mb-3">Competency Details</div>
          <table class="table table-striped bg-white table-sm">
            <tbody>
            <tr>
              <td>
                <span class="font-weight-bold">Task</span>
              </td>
              <td>
                {{ row.item.task }}
              </td>
            </tr>
            <tr>
              <td>
                <span class="font-weight-bold">Performance Objectives</span>
              </td>
              <td>
                {{ row.item.objectives }}
              </td>
            </tr>
            <tr>
              <td>
                <span class="font-weight-bold">Directions to Candidate</span>
              </td>
              <td>
                <div v-html="row.item.description"></div>
              </td>
            </tr>
            </tbody>
          </table>
          <hr>
          <div class="font-weight-bold mb-3">Steps</div>
          <table class="table table-striped bg-white table-sm">
            <tbody>
            <tr v-for="(step, index) in row.item.steps" :key="index">
              <td>
                {{ index + 1 }}
              </td>
              <td v-html="step"></td>
            </tr>
            </tbody>
          </table>
          <hr>
          <div class="font-weight-bold mb-3">Considerations / Critical Inclusions</div>
          <table class="table table-striped bg-white table-sm">
            <tbody>
            <tr v-for="(consideration, index) in row.item.considerations" :key="index">
              <td>
                {{ index + 1 }}
              </td>
              <td v-html="consideration"></td>
            </tr>
            </tbody>
          </table>
          <!-- <b-button @click="printComp(row.item.id)" class="btn btn-danger mb-2">
               <span class="icon icon-print"> Print</span>
          </b-button> -->
        </b-card>
      </template>
    </b-table>

    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0"/>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import swal from 'sweetalert';

const items = [];
export default {
  props: ['competencies', 'sent_today', 'current_category'],
  data() {
    return {
      items: this.competencies,
      category: this.current_category,
      sent_already: this.sent_today,
      fields: [
        {key: "title", label: "Competency", sortable: true, class: 'tcol2'},
        {key: "actions", label: "Actions"}
      ],
      currentPage: 1,
      perPage: 25,
      totalRows: this.competencies.length,
      pageOptions: [15, 25, 35, 50],
      filter: null,
      sortBy: null,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(f => f.sortable).map(f => {
        return {text: f.label, value: f.key};
      });
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    printComp(id) {
      window.location.href = "/competency/print/" + id;
    },
    sendComp(id, title) {
      Swal.fire({
        title: 'Ready to Send?',
        text: "You will now send " + title + " to be evaluated by a Preceptor.",
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok'
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = ('/competency/send/' + id);
        }
      });
    }
  },
  // mounted() {
  //   axios
  //     .get("/competency")
  //     .then(response => (this.items = response.data))
  //     .catch(function(error) {
  //       // handle error
  //       console.log(error);
  //     });
  // }
};
</script>

<!-- table-complete-1.vue -->